<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width: 100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员登记" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" v-show="submitShow" v-if="editData.djzt === '提交'" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="技术人员登记">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记表编号">
                                            <a-input ref="djsqbbh" v-model="editData.djsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="姓名" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="xm" v-model="editData.xm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="4">
                                        <div class="image-container">
                                            <UploadImage :attachCfg="attachCfg_Edit" :state="2" />
                                        </div>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="性别">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="民族" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="出生日期">
                                            <a-date-picker ref="csrq" v-model="editData.csrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="区域编号" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="证件类型" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="证件号码">
                                            <a-input ref="zjhm" v-model="editData.zjhm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="所属单位编号" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                                            <a-input ref="ssdwbh" v-model="editData.ssdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="所属单位名称">
                                            <a-input ref="ssdwmc" v-model="editData.ssdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="人员类别">
                                            <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职务">
                                            <a-input ref="zw" v-model="editData.zw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职称">
                                            <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职称专业">
                                            <a-input ref="zczy" v-model="editData.zczy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="批准时间">
                                            <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="毕业院校">
                                            <a-input ref="byyx" v-model="editData.byyx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="毕业时间">
                                            <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="所学专业">
                                            <a-input ref="sxzy" v-model="editData.sxzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="学历">
                                            <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="学位">
                                            <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="参加工作时间">
                                            <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="从业时间">
                                            <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="移动电话">
                                            <a-input ref="yddh" v-model="editData.yddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="个人简历">
                                            <a-input ref="grjl" v-model="editData.grjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="上岗证编号">
                                            <a-input ref="sgzbh" v-model="editData.sgzbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记状态">
                                            <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="editData.zczt" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row v-if="editData.zczt === '已登记'" :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="执业资格证书编号">
                                            <a-input ref="zyzgzsbh" v-model="editData.zyzgzsbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记单位编号">
                                            <a-input ref="zcdwbh" v-model="editData.zcdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row v-if="editData.zczt === '已登记'" :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记单位名称">
                                            <a-input ref="zcdwmc" v-model="editData.zcdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记时间">
                                            <a-date-picker ref="zcsj" v-model="editData.zcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记周期(年)">
                                            <a-input-number ref="zczq" v-model="editData.zczq" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="首次登记时间">
                                            <a-date-picker
                                                ref="sczcsj"
                                                v-model="editData.sczcsj"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                @change="onChange(editData.sczcsj)"
                                                disabled
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="下次登记时间">
                                            <a-date-picker ref="xczcsj" v-model="editData.xczcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记证(执业专用证)编号">
                                            <a-input ref="zczbh" v-model="editData.zczbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="主专业">
                                            <a-input ref="zzy" v-model="editData.zzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="辅专业">
                                            <a-input ref="fzy" v-model="editData.fzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="备注">
                                            <a-input ref="bz" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单据状态">
                                            <a-input ref="djzt" v-model="editData.djzt" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="确认意见">
                                            <a-input ref="qryj" v-model="editData.qryj" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="技术人员培训记录">
                                <vxe-table
                                    ref="itemPXJLTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    highlight-current-row
                                    show-overflow="tooltip"
                                    :data="editItemPXJLData"
                                >
                                    <vxe-table-column field="xh" title="序号" align="center" width="70px" sortable> </vxe-table-column>
                                    <vxe-table-column field="bjmc" title="班级名称" min-width="100px"> </vxe-table-column>
                                    <vxe-table-column field="bjlb" title="班级类别" align="center" width="130px"> </vxe-table-column>
                                    <vxe-table-column field="ksrq" title="报名开始日期" align="right" header-align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="jsrq" title="报名结束日期" align="right" header-align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pxksrq" title="培训开始日期" align="right" header-align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pxjsrq" title="培训结束日期" align="right" header-align="center" width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pxnr" title="培训内容" min-width="100px"> </vxe-table-column>
                                    <vxe-table-column field="pxdd" title="培训地点" min-width="100px"> </vxe-table-column>
                                    <vxe-table-column field="xs" title="学时" align="right" header-align="center" width="50px"> </vxe-table-column>
                                    <vxe-table-column field="sfhg" title="是否合格" align="center" width="100px">
                                        <template v-slot:edit="scope">
                                            <FGDictSelectCN ref="sfhg" dictNo="RY200102" v-model="scope.row.sfhg" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zsbh" title="证书编号" min-width="100px"> </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" min-width="100px"> </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="技术人员登记信息">
                                <vxe-table
                                    ref="itemZCXXTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZCXXData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column field="xh" title="序号" width="100" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.cgbh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zyzgzsbh" title="执业资格证书编号" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zyzgzsbh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcsj" title="登记时间" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcsj" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcdwbh" title="登记单位编号" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcdwbh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcdwmc" title="登记单位名称" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcdwmc" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zczbh" title="登记证(执业专用证)编号" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zczbh" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zzy" title="主专业" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zzy" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="fzy" title="辅专业" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.fzy" />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload ref="attachdown" :isShow="formIsVisible" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "JsrydjForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            tableData: [],
            // 培训记录明细数据
            editItemPXJLData: [],
            editItemPXJLDataLoading: false,
            // 登记信息明细数据
            editItemZCXXData: [],
            editItemZCXXDataLoading: false,
            isShow: false,
            isShowIcon: true
        };
    },
    activated() {
        this.submitShow = true;
        // 修改，加载数据
        this.loadData();
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "RY_DJSQB",
                fkfield: "ID",
                fkvalue: this.editDataId,
                attachsource: "RY2000"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "RY_DJSQB",
                fkvalue: this.editData.id
            };
        }
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.formIsVisible = false;
                    }
                    this.loadItemPXJLData();
                    this.loadItemZCXXData();
                });
        },
        // 加载明细表数据
        loadItemPXJLData() {
            this.editItemPXJLData = [];
            this.editItemPXJLDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/listPXJL",
                    {
                        jsryid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemPXJLDataLoading = false;
                    if (success) {
                        this.editItemPXJLData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemZCXXData() {
            this.editItemZCXXData = [];
            this.editItemZCXXDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsrydj/listZCXX",
                    {
                        jsryid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZCXXDataLoading = false;
                    if (success) {
                        this.editItemZCXXData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.saving = true;
                    this.$FG_http
                        .post("./api/main/jsry/jsrydj/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.hymc.focus();
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        }
    }
};
</script>
